import { LiveEventCard, TopLiveEventCard } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import type { EventWithPrice } from '~/shared/interfaces'
import { $liveLabel } from '~/shared/ui/translations'
import type { ViewRow } from '~/widgets/DynamicModule'
import { getCardFonts, getRowType } from '../lib'

export const EventCard = ({
  row,
  item,
  idx,
}: {
  row: ViewRow
  item: EventWithPrice
  idx: number
}) => {
  const {
    videoPosterUrl,
    videoVerticalPosterUrl,
    free,
    rented,
    name,
    id,
    labelPrice,
    isLive,
    ageRatings,
    formattedStartTime,
  } = item

  const {
    appearance: {
      style: { posterOrientation, posterSize, topContent },
    },
  } = row

  const { liveLabel } = useUnit({
    liveLabel: $liveLabel,
  })

  const posterUrl =
    posterOrientation === 'HORIZONTAL' ? videoPosterUrl : videoVerticalPosterUrl

  const { titleFont, labelFont } = getCardFonts(posterSize)

  const Card = topContent ? TopLiveEventCard : LiveEventCard
  const topNumber = idx + 1
  const type = getRowType(row)

  return (
    <a href={`/events/${id}`}>
      <Card
        posterUrl={posterUrl}
        title={ageRatings}
        liveTitle={liveLabel}
        isLive={isLive}
        purchaseTitle={labelPrice}
        rented={rented}
        free={free}
        titleTimeLabel={formattedStartTime}
        description={name}
        descriptionFont={titleFont}
        labelFont={labelFont}
        topNumber={topNumber}
        type={type}
      />
    </a>
  )
}
